module.exports = __webpack_public_path__ + "b762275ca5ba26cb589ff78355bd41fc.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/ER.svg
// module id = CpyJ
// module chunks = 0